/**
 * Minimal DOM helpers shared by the UI layer.
 */

/** querySelector, typed. */
export function $<T extends HTMLElement = HTMLElement>(
  selector: string,
  root: ParentNode = document
): T | null {
  return root.querySelector<T>(selector);
}

/** querySelectorAll as an array, typed. */
export function $$<T extends HTMLElement = HTMLElement>(
  selector: string,
  root: ParentNode = document
): T[] {
  return Array.from(root.querySelectorAll<T>(selector));
}

/** getElementById, typed. */
export function byId<T extends HTMLElement = HTMLElement>(id: string): T | null {
  return document.getElementById(id) as T | null;
}

/** Read the trimmed value of an input/select/textarea by id ('' if absent). */
export function inputValue(id: string): string {
  const el = document.getElementById(id) as
    | HTMLInputElement
    | HTMLSelectElement
    | HTMLTextAreaElement
    | null;
  return el ? el.value.trim() : '';
}

/** Set the value of an input/select/textarea by id, if present. */
export function setInputValue(id: string, value: string): void {
  const el = document.getElementById(id) as
    | HTMLInputElement
    | HTMLSelectElement
    | HTMLTextAreaElement
    | null;
  if (el) el.value = value;
}

/** addEventListener with null-safety. */
export function on<K extends keyof HTMLElementEventMap>(
  target: EventTarget | null,
  type: K,
  handler: (event: HTMLElementEventMap[K]) => void
): void {
  target?.addEventListener(type, handler as EventListener);
}
